export default __webpack_public_path__ + "static/media/870.36ed01c3.png";